/* 
  Enriched Mock Data for SoundNest 
  Updated with 100% reliable SoundHelix open test streams and Demo Sample Data
*/

export const moods = [
  { id: '1', name: 'Cyberpunk City', color: 'bg-plasma', icon: 'FiZap', energy: 90, frequency: '142Hz' },
  { id: '2', name: 'Deep Space', color: 'bg-aqua', icon: 'FiMoon', energy: 30, frequency: '40Hz' },
  { id: '3', name: 'Neon Drive', color: 'bg-purple-500', icon: 'FiNavigation', energy: 75, frequency: '110Hz' },
  { id: '4', name: 'Analog Chill', color: 'bg-orange-500', icon: 'FiCoffee', energy: 40, frequency: '65Hz' },
  { id: '5', name: 'Hyper Pop', color: 'bg-pink-400', icon: 'FiSun', energy: 95, frequency: '180Hz' },
  { id: '6', name: 'Midnight Jazz', color: 'bg-indigo-600', icon: 'FiMusic', energy: 20, frequency: '52Hz' },
];

export const tracks = [
  { 
    id: 't1', 
    title: 'Neon Rain', 
    artist: 'Synthwave Syndicate', 
    duration: '6:12', 
    cover: 'https://images.unsplash.com/photo-1614613535308-eb5fbd3d2c17?q=80&w=150&auto=format&fit=crop', 
    status: 'Optimal',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'
  },
  { 
    id: 't2', 
    title: 'Hologram Heart', 
    artist: 'Data Romance', 
    duration: '7:05', 
    cover: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?q=80&w=150&auto=format&fit=crop', 
    status: 'Optimal',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3'
  },
  { 
    id: 't3', 
    title: 'Quantum Leap', 
    artist: 'The Grid', 
    duration: '5:44', 
    cover: 'https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=150&auto=format&fit=crop', 
    status: 'De-synced',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3'
  },
  { 
    id: 't4', 
    title: 'Binary Sunset', 
    artist: 'System Override', 
    duration: '5:02', 
    cover: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=150&auto=format&fit=crop', 
    status: 'Optimal',
    audioUrl: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3'
  }
];

export const artists = [
  { id: 'a1', name: 'Synthwave Syndicate', followers: '1.2M', image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?q=80&w=300&auto=format&fit=crop', listeners: '45k' },
  { id: 'a2', name: 'Data Romance', followers: '845K', image: 'https://images.unsplash.com/photo-1493225457124-a1a2a5956093?q=80&w=300&auto=format&fit=crop', listeners: '12k' },
];

export const friends = [
  { id: 'f1', name: 'Alex_V', status: 'listening', track: 'Neon Rain', avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=100&auto=format&fit=crop' },
  { id: 'f2', name: 'SarahD', status: 'room', roomName: 'Cyberpunk Session', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=100&auto=format&fit=crop' },
  { id: 'f3', name: 'Kai_Neon', status: 'offline', track: '', avatar: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?q=80&w=100&auto=format&fit=crop' },
];

export const rooms = [
  { id: 'r1', name: 'Late Night Coding', host: 'Data Romance', listeners: 124, genre: 'Synthwave', tags: ['chill', 'focus'] },
  { id: 'r2', name: 'Bass Drop Central', host: 'DJ Plasma', listeners: 892, genre: 'Electronic', tags: ['hype', 'party'] },
  { id: 'r3', name: 'Lo-Fi Sector 7', host: 'Alex_V', listeners: 56, genre: 'Lo-Fi', tags: ['study', 'rain'] },
];

export const systemMetrics = [
  { label: 'Network Pulse', value: '98.4%', trend: 'up' },
  { label: 'Sync Latency', value: '12ms', trend: 'down' },
  { label: 'Active Rooms', value: '1,402', trend: 'up' },
  { label: 'Total Frequencies', value: '4.2M', trend: 'up' },
];

export const demoSampleData = [
  { id: 'SN-8821', session: 'Deep Focus Alpha', user: 'Alex_V', status: 'Active', duration: '02:14:30', nodes: 42 },
  { id: 'SN-8822', session: 'Cardio Rhythm Beta', user: 'SarahD', status: 'Completed', duration: '00:45:00', nodes: 12 },
  { id: 'SN-8823', session: 'Sleep Theta Wave', user: 'Kai_Neon', status: 'Failed', duration: '00:00:00', nodes: 0 },
  { id: 'SN-8824', session: 'Cyberpunk Stream', user: 'System Override', status: 'Active', duration: '05:12:11', nodes: 892 },
  { id: 'SN-8825', session: 'Morning Coffee Mix', user: 'Data Romance', status: 'Processing', duration: '--:--:--', nodes: 5 },
];